class FindComponent {


    // CLASS CONSTRUCTOR
    constructor() {
        this.init();
    }


    // CLASS INITIALIZATION
    init() {
        const _self = this;
        const wrapper = document.querySelector('#component_image');
        const imageMap = wrapper.querySelector('[name="image_map"]');
        const imageMapAreas = imageMap.querySelectorAll('area');

        // Instanciate image map resizer to keep areas working when the image is resizing
        imageMapResize(imageMap);

        // 

        // For each area of the image map
        imageMapAreas.forEach(area => {

            // Initialize tippy
            const tippyElt = tippy(area, {
                allowHTML: true,
                followCursor: "initial",
                theme: "material",
                interactive: true,
                trigger: 'manual',
                maxWidth: 350,
            });

            // Prevent default behavior
            area.addEventListener('click', function(e) {
                e.preventDefault();
                console.log('click');
                _self.openAreaTooltip(this);
            });
        });
    }


    // OPEN TOOLTIP FOR AREA
    openAreaTooltip(area) {
        const _self = this;
        const productId = parseInt(area.getAttribute('href'));
        const tippyInst = area._tippy;

        // Set loading content inside the tippy tooltip and show this last
        tippyInst.setContent(_self.getLoadingTemplate("Veuillez patienter..."));
        tippyInst.show();

        // Get the product datas to be displayed inside the tooltip
        $.ajax('/ajax/tippy-product/' + productId).then(res => {
            if (res.data.error) { throw new Error(res); }
            tippyInst.setContent(res.data);
        }).catch(error => {
            console.error(error);
        });


    }


    // Get loading template 
    getLoadingTemplate(message) {
        return `
            <div class="tippy-loading-wrap">
                <div class="loading-wrap">
                    <span class="loader-1"></span>
                    <span class="text-white">${message}</span>
                </div>
            </div>
        `;
    }

}

$(document).ready(function() {
    new FindComponent;
}); 